import initCustomScrollbar from "../modules/init-custom-scrollbar.js";
import { breakpointResizer } from "../utils/globals.js";

const accordionModule = $section => {
	const $accordion = $section.find( ".js-accordion" );
	const $items = $accordion.find( ".js-accordion-item" );
	const $spine = $items.find( ".js-accordion-spine" );
	const $subSpine = $items.find( ".js-accordion-spine-secondary" );
	const resizer = breakpointResizer();
	const $arrowPrev = $section.find( ".js-accordion-arrow-prev" );
	const $arrowNext = $section.find( ".js-accordion-arrow-next" );

	const toAccordion = function() {
		$items.each( function() {
			const $item = $( this );

			if ( $item.hasClass( "active" ) ) {
				setTimeout( () => {
					const $info = $item.find( ".js-accordion-info" );
					const $infoContent = $item.find( ".js-accordion-info__wrapper" );

					resizer.breakpointDown( "small-desktop", () => {
						$info.height( $infoContent.outerHeight() );

						let scrollHeight = $info.offset().top;
						let headerHeight = 0;
						let adminbarHeight = 0;

						if ( $( ".section-header" ).length ) {
							headerHeight = $( ".section-header" ).outerHeight();
						}

						if ( $( "#wpadminbar" ).length ) {
							adminbarHeight = $( "#wpadminbar" ).outerHeight();
						}

						$( "html, body" ).scrollTop( scrollHeight - headerHeight - adminbarHeight - 10 );
					} );
				}, 500 );
			}
		} );
	};

	const removeCurrent = function() {
		$items.each( function() {
			if ( !$( this ).hasClass( "active" ) ) {return;}

			$( this ).removeClass( "active" );
			$( this ).find( ".subservice-dropdown" ).removeClass( "open" );
			$( this ).find( ".js-accordion-spine-secondary" ).removeClass( "active" );

			resizer.breakpointDown( "small-desktop", () => {
				const $info = $( this ).find( ".js-accordion-info" );

				$info.animate( { height: 0 }, 500, "swing", function() {
					$info.removeAttr( "style" );
					$info.find( ".js-accordion-info__wrapper-secondary" ).addClass( "hide" );
					$info.find( ".js-accordion-info__wrapper" ).removeClass( "hide" );
				} );
			} );
		} );
	};

	const setTab = function() {
		const $item = $( this ).closest( ".js-accordion-item" );
		$item.find( ".js-accordion-info__wrapper-secondary" ).addClass( "hide" );
		$item.find( ".js-accordion-info__wrapper" ).removeClass( "hide" );
		$item.find( ".subservice-dropdown" ).toggleClass( "open" );
		$( ".js-accordion-spine-secondary" ).removeClass( "active" );

		if ( $item.hasClass( "active" ) ) {
			return;
		}

		const $info = $item.find( ".js-accordion-info" );
		const $infoContent = $item.find( ".js-accordion-info__wrapper" );

		removeCurrent();

		$item.addClass( "active" );
		$item.find( ".subservice-dropdown" ).addClass( "open" );

		resizer.breakpointUp( "small-desktop", () => {
			const $scrollableContainer = $item.parent( ".scrollbar-outer" );
			$scrollableContainer.scrollTop( $item.position().top );
		} );

		resizer.breakpointDown( "small-desktop", () => {
			$info.animate( { height: $infoContent.outerHeight() }, 500 );
			setTimeout( () => {
				let scrollHeight = $info.offset().top;
				let headerHeight = 0;
				let adminbarHeight = 0;

				if ( $( ".section-header" ).length ) {
					headerHeight = $( ".section-header" ).outerHeight();
				}

				if ( $( "#wpadminbar" ).length ) {
					adminbarHeight = $( "#wpadminbar" ).outerHeight();
				}

				$( "html, body" ).scrollTop( scrollHeight - headerHeight - adminbarHeight - 10 );

			}, 500 );
		} );
	};

	const clear = function() {
		$items.find( ".js-accordion-info" ).removeAttr( "style" );
	};

	toAccordion();

	resizer.between( ["small-desktop", "tablet", "mobile", "mobile-medium", "mobile-small"], toAccordion );
	resizer.between( ["desktop", "large-desktop", "4k"], clear );

	$spine.on( "click", setTab );

	$subSpine.on( "click", function( e ) {
		e.preventDefault();
		$( ".js-accordion-spine-secondary" ).removeClass( "active" );
		$( this ).addClass( "active" );
		const $item = $( this ).closest( ".js-accordion-item" );
		const targetId = $( this ).data( "target" );
		const $targetTab = $( targetId );
		const $mainTab = $item.find( ".js-accordion-info__wrapper" );
		$mainTab.addClass( "hide" );
		$( ".js-accordion-info__wrapper-secondary" ).addClass( "hide" );
		$targetTab.removeClass( "hide" );
	} );

	$arrowPrev.on( "click", function( e ) {
		e.preventDefault();
		const $itemActive = $accordion.find( ".js-accordion-item.active" );

		if ( $itemActive.prev().length ) {
			$itemActive.prev().find( ".js-accordion-spine" ).trigger( "click" );
		} else {
			$items.last().find( ".js-accordion-spine" ).trigger( "click" );
		}
	} );

	$arrowNext.on( "click", function( e ) {
		e.preventDefault();
		const $itemActive = $accordion.find( ".js-accordion-item.active" );
		if ( $itemActive.next().length ) {
			$itemActive.next().find( ".js-accordion-spine" ).trigger( "click" );
		} else {
			$items.first().find( ".js-accordion-spine" ).trigger( "click" );
		}
	} );
};
const initBlock = async function( block ) {

	await import( "../plugins/scrollbar.min.js" );

	accordionModule( block );
	initCustomScrollbar( block, false );
};

themeUtils.loadBlock( initBlock, "our-services", ".section-our-services" );
